import { generateTotp } from './totp';

export const CARDS_CACHE_KEY = 'c-v2';
const OLD_CARDS_CACHE_KEY = 'c';
const CARDS_LIST_PATH = '/cards/listar/cartoes-e-produtos';
const APP_ID = 'br.com.onlypay.onlyone';
const OP_06 = 'only_pay_package';
const OP_VERSION = 'web - platform: web - version: 0.1.1';
let listCardsInFlight = null;

export function formatLocalDateHeader(date = new Date()) {
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function mapListedCard(card = {}) {
  const balance = card.balance == null ? 0 : Number(card.balance);
  return {
    ...card,
    id: card.cardId,
    idConta: card.accountId,
    numeroCartao: card.cardNumber,
    nomeImpresso: card.cardName,
    dataValidade: card.expirationDate,
    idProduto: Number(card.produtoIdDock),
    idStatusCartao: card.statusCard,
    flagVirtual: card.virtual,
    cartaoVirtual: card.virtual,
    saldo: Number.isNaN(balance) ? 0 : balance
  };
}

export function sortCardsByUnlockDate(cards = []) {
  return [...cards].sort((a, b) => {
    if (a.unlockDate == null && b.unlockDate == null) return 0;
    if (a.unlockDate == null) return -1;
    if (b.unlockDate == null) return 1;
    return new Date(b.unlockDate) - new Date(a.unlockDate);
  });
}

export function mapCardsListResponse(data = {}) {
  const cards = sortCardsByUnlockDate((data.cards || []).map(mapListedCard));
  return {
    cards,
    hasNewCard: Boolean(data.hasNewCard),
    hasNewDigitalCard: Boolean(data.hasNewDigitalCard),
    hasNewPhisicalCardCOP: false,
    IsCardsEmpty: Boolean(data.IsCardsEmpty)
  };
}

export function clearCardsCache() {
  localStorage.removeItem(OLD_CARDS_CACHE_KEY);
  localStorage.removeItem(CARDS_CACHE_KEY);
}

export function setCachedCardsList(payload) {
  localStorage.removeItem(OLD_CARDS_CACHE_KEY);
  localStorage.setItem(CARDS_CACHE_KEY, JSON.stringify(payload));
}

export async function buildCardsListHeaders() {
  const [op03, op05] = await Promise.all([
    generateTotp(APP_ID, 6),
    generateTotp(process.env.VUE_APP_OP_05_SECRET, 8)
  ]);

  return {
    'ope-02': process.env.VUE_APP_OPE_02_TENANT_ID,
    'op-03': op03,
    'op-04': '',
    'op-05': op05,
    'op-06': OP_06,
    'op-07': process.env.VUE_APP_OP_07_CARDS_LIST,
    'app-id': APP_ID,
    date: formatLocalDateHeader(),
    'op-version': OP_VERSION,
    'Content-Type': 'application/json'
  };
}

export async function listCardsAndProducts(httpClient) {
  if (listCardsInFlight) {
    return listCardsInFlight;
  }

  listCardsInFlight = (async () => {
    const headers = await buildCardsListHeaders();
    const response = await httpClient.get(CARDS_LIST_PATH, { headers });
    const mapped = mapCardsListResponse((response && response.data) || {});
    setCachedCardsList(mapped);
    return mapped;
  })().finally(() => {
    listCardsInFlight = null;
  });

  return listCardsInFlight;
}
